import { config } from "@/config";

import { cn } from "./cn";

/** Which environment this build is (STAGE, LOCAL); nothing in prod, so test and real are never confused. */
export function EnvironmentTag({ className }: { className?: string }) {
  if (config.appEnv === "prod") return null;
  return (
    <span
      className={cn(
        "rounded-md bg-warn-soft px-2 py-0.5 text-[11px] font-bold tracking-wide text-warn uppercase",
        className,
      )}
    >
      {config.appEnv}
    </span>
  );
}
